import { render, staticRenderFns } from "./DepartmentHospital.vue?vue&type=template&id=2578e045&scoped=true&"
import script from "./DepartmentHospital.vue?vue&type=script&lang=js&"
export * from "./DepartmentHospital.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentHospital.vue?vue&type=style&index=0&id=2578e045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578e045",
  null
  
)

export default component.exports